import type { UserRoleName } from 'src/generated'
import { COSTS_ROLES } from './costs'

// ----------------------------------------------------------------------
// Who may see the Business page.
//
// It sets what operators pay Beast against what Beast pays its vendors: one
// operator's invoices beside another's, and Beast's own costs. Beast staff
// only, as `businessOverview` is on the backend (`@auth(roles: [superAdmin])`
// and `ensureBeastAdmin`, held by `businessBeastOnly.test.ts`), and the same
// people as the Costs pages, which it is made from. See docs/BUSINESS.md.
// ----------------------------------------------------------------------

/** The roles the Business page admits: the Costs pages' own. */
export const BUSINESS_ROLES: readonly UserRoleName[] = COSTS_ROLES

/** Whether this viewer may see the Business page. */
export const businessVisibleTo = (
  role: UserRoleName | null | undefined,
): boolean => role != null && BUSINESS_ROLES.includes(role)
